import React, {useEffect, useContext} from 'react'
import { TitleContext, PathContext } from "../../Context";
export const pageUrl = () => "/jquery/introduction";

export default function Introduction() {

    const title = useContext(TitleContext);
    const path = useContext(PathContext);
    useEffect(() => {
        title.setPageTitle("An Introduction to jQuery | Aspirant's Home");
        const urls = {
            'next': '/jquery/get-started'
        }
        path.setPreviousNext(urls);
    }, [])

    return (
        <section className='mt-5 mb-5'>
            <h3>What is jQuery ?</h3>
            <div className='mt-4 mb-5'>
                <p>
                    jQuery is a <strong>JavaScript library</strong> that makes it easier to write JavaScript code. jQuery is <strong>lightweight</strong> and <strong>quick to load</strong>, so it doesn’t slow down your website. 
                </p>
                <p>It helps you do things like changing parts of a webpage, handling user actions (like clicks), and adding animations. </p>
                <p>jQuery has a <strong>simpler syntax</strong>, meaning you can <strong>write less code</strong> to do the same things you would with plain JavaScript.</p>

                <p>Web browsers (like Chrome, Firefox, etc.) can handle JavaScript slightly differently. jQuery smooths out these <strong>differences</strong>, so your code works <strong>the same across all browsers</strong>.</p>

                <h3 className='mt-5 mb-3'>Why Use jQuery?</h3>
                <ul style={{ listStyle: 'decimal' }}>
                    <li className='operator'>
                        <h5>Simplified Syntax</h5>
                        <p>In JavaScript, writing code to interact with a webpage can sometimes be long and complicated. jQuery makes this easier by providing <strong>shorter and simpler commands</strong>. This means you can accomplish the same tasks with <strong>less code.</strong></p>
                    </li>
                    <li className='operator'>
                        <h5>Cross-Browser Compatibility</h5>
                        <p>Different browsers (like Chrome, Firefox, Safari, etc.) sometimes handle JavaScript slightly differently. This can cause your code to work fine on one browser but fail on another. jQuery handles these differences for you, so you don’t need to worry about making your code work in every browser.</p>
                    </li>
                    <li className='operator'>
                        <h5>Rich Features</h5>
                        <p>jQuery comes with a lot of built-in features that make it easier to work with webpages. Some of the main features include:</p>
                        <ul style={{ listStyle: 'disc' }}>
                            <li><strong>DOM Manipulation</strong>: This means changing, adding, or removing HTML elements on the page. For example, you could use jQuery to add a new paragraph or change the color of a button.</li>

                            <li><strong>AJAX Calls</strong>: AJAX allows you to <strong>fetch data from a server without reloading the page</strong>. This is useful for loading new content dynamically, like showing the latest news without the user needing to refresh the page.</li>

                            <li><strong>Animations</strong>: You can easily add animations, like making elements fade in or out, slide up or down, etc., with simple jQuery commands.</li>

                            <li><strong>Event Handling</strong>: jQuery simplifies handling user actions, like clicks, hovers, and form submissions. For example, if you want something to happen when a user clicks a button, jQuery makes it easy to set this up.</li>
                        </ul>
                        <p>These features allow you to create more <strong>interactive and dynamic</strong> websites with fewer lines of code.</p>
                    </li>
                    <li className='operator'>
                        <h5>Lightweight</h5>
                        <p>The jQuery library is <strong>small in file size</strong> (compared to other libraries or frameworks), so it doesn’t take long to load.</p>
                        <p>Because it’s small, using jQuery won’t significantly slow down your website. It’s designed to be <strong>efficient and fast</strong>.</p>
                    </li>
                </ul>



            </div>
        </section>
    )
}